import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-project-preview-loading',
  templateUrl: './project-preview-loading.component.html',
  styleUrls: ['./project-preview-loading.component.scss'],
})
export class ProjectPreviewLoadingComponent {
  @Input() show = false;
  @Input() text: string = 'The project is being created...';
}

